// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileBulkFollowModal-cls1_pZ_","cls2":"ProfileBulkFollowModal-cls2_nSP ProfileBulkFollowModal-cls1_pZ_"};